import axios from "axios";
import Constants from "@/constants";

const http = axios.create({
    baseURL: Constants.baseUrl,
});

export default http;
